import React from 'react';
import { Create, SimpleForm, TextInput, ReferenceInput, SelectInput } from 'react-admin';

const isHierarchy = true; // expects true or false injected by plop

export const BusinessUnitCreate = (props) => {
    const defaultReferenceSort = { field: "name_path", order: "ASC" }
    return (
    <Create {...props}>
        <SimpleForm redirect='list'>
            <TextInput fullWidth label="Business Unit Name" source="text" />
            {(isHierarchy) && <ReferenceInput
                reference="kraftheinz_business_unit"
                source="parent"
                perPage={500}
                fullWidth
                sort={defaultReferenceSort}
                filterToQuery={(searchText) => ({ 'name_path@ilike':  `${encodeURIComponent(searchText)}` })}
            >
            <SelectInput
                optionText="name_path"
            />
            </ReferenceInput>}
        </SimpleForm>
    </Create>
)};
export default BusinessUnitCreate